/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable,} from '@angular/core';
import { Router } from '@angular/router';
import { AbInfoPopupService } from './ab-info-popup.service';

@Injectable({
  providedIn: 'root'
})
export class PopupService {
  dialogTransitionTime = '40ms';
  closeOutside = false;
  showResponseDelay=false;
  showInfoPopup = false;
  dialogMessage = '';
  dialogTitle = '';
  isDialogVisible = false;
  message = "You've made too many requests.";
  countdown = 60; // Default wait time (60 seconds)
  interval: any;
  constructor(private _router:Router,private _abpopupinfo:AbInfoPopupService){}

  handleClick(): void {
    const url = this._router.url.split('/')[1]
    if (url==='') {
      if(this.showInfoPopup){
        this._abpopupinfo.getdata();
      }
      this.showInfoPopup = true
    }
  }
  startCountdown() {
    this.interval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.interval);
      }
    }, 100);
  }
  showWarning(title: string, message: string): void { 
    this.isDialogVisible = true;
    this.dialogTitle = title;
    this.message = message;
    this.startCountdown();
  }
  closeDialog(){
    this.dialogTitle = '';
    this.message = '';
    clearInterval(this.interval);
    window.location.reload();
    this.isDialogVisible = false;
  }
}
